module.exports = __webpack_public_path__ + "img/cad.b71457da.svg";